<div class="wrapper-body">
  <div class="ppl-tabs">

    <nz-tabset [nzAnimated]="false" [nzTabBarGutter]="8" [nzTabBarStyle]="{ 'margin-bottom': '12px' }"
      [nzType]="'line'" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="onTabIndexChange($event)">
      <nz-tab *ngFor="let menuItem of horizontalMenuItemstoDisplay" [nzTitle]="menuItem.menu_label"></nz-tab>
    </nz-tabset>

    <!-- Tab Content -->
    <div class="tab-content" [ngSwitch]="selectedMenuItem?.toLowerCase()">
      <ppl-lead-detail-summary *ngSwitchCase="'summary'" [readOnly]="true"></ppl-lead-detail-summary>
      <ppl-lead-information *ngSwitchCase="'enrollmentinformation'" [readOnly]="true"></ppl-lead-information>
      <ppl-authorization *ngSwitchCase="'authorizations'" [readOnly]="true"></ppl-authorization>
      <ppl-associations *ngSwitchCase="'associations'" [readonly]="true"></ppl-associations>
      <ppl-form-checklist *ngSwitchCase="'forms'" [readonly]="true"></ppl-form-checklist>
      <ppl-additional-attributes *ngSwitchCase="'additionalattributes'" [readonly]="true"></ppl-additional-attributes>
      <ppl-checklist *ngSwitchCase="'checklist'" [readonly]="true"></ppl-checklist>
      <ppl-documents *ngSwitchCase="'documents'" [readonly]="true"></ppl-documents>
      <ppl-to-do-list *ngSwitchCase="'todolist'"></ppl-to-do-list>
      <ppl-consumer-rates *ngSwitchCase="'consumerrates'" [mode]="'read'"></ppl-consumer-rates>
      <ppl-lead-detail-signature *ngSwitchCase="'signature'"></ppl-lead-detail-signature>
      <ng-container *ngSwitchCase="'sicktime'">
        <app-participant-sick-time *ngIf="isParticipant"></app-participant-sick-time>
        <app-provider-sick-time *ngIf="!isParticipant" [isReadOnly]="true"></app-provider-sick-time>
      </ng-container>
      <ppl-purchase-request-participant-view *ngSwitchCase="'purchaserequests'"></ppl-purchase-request-participant-view>
      <ng-container *ngSwitchCase="'invoice'">
        <ppl-invoice-consumer-list *ngIf="isParticipant"></ppl-invoice-consumer-list>
        <ppl-provider-invoice *ngIf="!isParticipant"></ppl-provider-invoice>
      </ng-container>
      <ng-container *ngSwitchCase="'timesheet'">
        <ppl-timesheet-consumer-list *ngIf="isParticipant"></ppl-timesheet-consumer-list>
        <ppl-timesheet-provider-list *ngIf="!isParticipant"></ppl-timesheet-provider-list>
      </ng-container>
    </div>
  </div>
</div>